import StyledWrapper, { getStyledWrapper } from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getDefaultPageSize, getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getCartState, getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import {
    getCurrentPromotionsDataView,
    getPromotionsDataView,
} from "@insite/client-framework/Store/Data/Promotions/PromotionsSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import CartLinesList, { CartLinesListStyles } from "@insite/content-library/Components/CartLinesList";
import { CheckoutReviewAndSubmitPageContext } from "@insite/content-library/Pages/CheckoutReviewAndSubmitPage";
import Button from "@insite/mobius/Button";
import LoadingSpinner from "@insite/mobius/LoadingSpinner";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { secondaryButton } from "@tKgpco/Extensions/Widgets/MyLists/MyListsCreateListButtonExtension";
import React, { FC, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

export interface BackToTopButtonStyles {
    centeringWrapper?: InjectableCss;
    orderLinesList?: CartLinesListStyles;
    footerWrapper?: InjectableCss;
}

export const BackToTopButtonStyles: BackToTopButtonStyles = {
    footerWrapper: {
        css: css`
            display: flex;
            justify-content: flex-end;
            .btn-backToTop {
                margin-right: 0;
                margin-top: 10px;
            }
        `,
    },
};

const styles = BackToTopButtonStyles;
const StyledSection = getStyledWrapper("section");

const BackToTopButton: FC = () => {
    const backToTopClickHandler = () => {
        window.scrollTo({
            top: 100,
            left: 0,
            behavior: "smooth",
        });
    };
    return (
        <>
            <StyledSection {...styles.footerWrapper}>
                <Button onClick={backToTopClickHandler} className="btn-backToTop" {...secondaryButton.createListButton}>
                    {translate("Back to Top")}
                </Button>
            </StyledSection>
        </>
    );
};

const widgetModule: WidgetModule = {
    component: BackToTopButton,
    definition: {
        displayName: "Back To Top Button",
        group: "Common",
    },
};

export default widgetModule;
